import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthStore {
  userId: string | null;
  email: string | null;
  phone: string | null;
  setUserDetails: (details: {
    userId?: string | null;
    email?: string | null;
    phone?: string | null;
  }) => void;
  clearAll: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      userId: null,
      email: null,
      phone: null,

      setUserDetails: (details) =>
        set({
          userId: details.userId ?? null,
          email: details.email ?? null,
          phone: details.phone ?? null,
        }),

      clearAll: () => set({ userId: null, email: null, phone: null }),
    }),
    {
      name: "guest-connect-auth",
    },
  ),
);
